import { render, staticRenderFns } from "./batchInfos.vue?vue&type=template&id=3c80433e&scoped=true&"
import script from "./batchInfos.vue?vue&type=script&lang=js&"
export * from "./batchInfos.vue?vue&type=script&lang=js&"
import style0 from "./batchInfos.vue?vue&type=style&index=0&id=3c80433e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c80433e",
  null
  
)

export default component.exports